import React, { useEffect, useState } from "react";
import Dynamic_PR_table from "../../../components/Dynamic_PR_table";
import { GetServiceCaller } from "../../../services/serviceCaller";
import { API_URL } from "../../../constants";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../constants/layout/store/filterSlice";

const DueExtensionReport = () => {
  // fetch data from api
  const [dueExtension, setdueExtension] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Due Extensions Report"));
  }, []);

  const columns = {
    Code: { text: "EMP ID", align: "start", visible: true },
    EmployeeName: { text: "Consultant Name", visible: true },
    ClientName: { text: "Customer Name", visible: true },
    name: { text: "Project Name", visible: true },
    ProjectTypes: { text: "Project Type", visible: true },
    ROMPoC: { text: "ROM POC",  visible: false },
    AccountManager:{ text: "Acc. Manager",  visible: false },
    CP_Name: { text: "CP Name",  visible: false },
    DP_Name: { text: "DP Name",  visible: false },
    PM_Name: { text: "PM Name",  visible: false },
    FromDate: { text: "Start Date", align: "center", visible: true },
    ToDate: { text: "End Date", align: "center", visible: true },
    InvoiceRate: { text: "Billing Rate", align: "end", visible: true }
  };
  useEffect(() => {
    fetchDueExtension();
  }, []);

  const [apiStatus, setApiStatus] = useState(undefined);
  const fetchDueExtension = async () => {
    try {
      const response = await GetServiceCaller(`${API_URL}rom-report/5`);

      if (response.status === 200) {
        setApiStatus(response?.status);
        const benchProject = response.data.header;
        setdueExtension(benchProject);
      } else {
        console.error(
          "Failed to fetch Course. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Due Extenion Report:", error);
    }
  };

  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <div className="row">
            <Dynamic_PR_table
              data={dueExtension}
              columns={columns}
              itemsPerPage={8}
              isSorting={true}
              searchTerm={searchTerm}
              isApiStatus={apiStatus}
              isRequiredStatus={true}
              setSearchTerm={setSearchTerm}
              isActionRequired={false}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default DueExtensionReport;
